import type { FunctionComponent } from 'react';
import { Disclaimer, DISCLAIMER_NAMES } from '@fff-web/cms';
import { appEnv } from '../../../utils/env';
import ReactivateButton from '../ReactivateButton';
import * as styles from './ReactivateTodayDisclaimer.module.scss';

type ReactivateTodayDisclaimerProps = {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  setShowRetry: (showRetry: boolean) => void;
};

const ReactivateTodayDisclaimer: FunctionComponent<ReactivateTodayDisclaimerProps> = ({
  isLoading,
  setIsLoading,
  setShowRetry,
}) => (
  <div className={styles.reactivateTodayDisclaimer} data-testid="reactivate-today-disclaimer">
    <Disclaimer name={DISCLAIMER_NAMES.reactivateToday1} env={appEnv} />
    <ReactivateButton
      text="REACTIVATE ME"
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      setShowRetry={setShowRetry}
    />
    <Disclaimer name={DISCLAIMER_NAMES.reactivateToday2} env={appEnv} />
  </div>
);

export default ReactivateTodayDisclaimer;
